export class GALLERY_VARIABLE {
    static readonly DEFAULT = 'nogallery';
    static readonly VIDEO = 'v';
    static readonly VIDEO_LABEL = 'video';
    static readonly HINH = 'h';
    static readonly HINH_LABEL = 'hinh';
    static readonly LINK_NHUNG = 'https://www.youtube.com/embed'
}
